// army-trails.js                                        ~/js/swipers
///////////////////////////////////////////////////////////////////////////

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Army Trails Page - Trails Swiper
export const ArmyTrailsSwiper = new Swiper('.army-trails-swiper-container', {
  modules: [Navigation, Pagination, Autoplay],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: true,
});
